export const defaultBillingTiers = [
  {
    id: "basic",
    name: "Basic",
    monthlyPrice: 100,
    annualPrice: 50,
    summary: "Essential records for clubs moving beyond spreadsheets.",
    features: [
      "Core operational records",
      "1 table at a time",
      "20 active members",
      "Current session data only",
      "No mobile app or tournaments",
    ],
  },
  {
    id: "standard",
    name: "Standard",
    monthlyPrice: 200,
    annualPrice: 150,
    summary: "A full operating layer with Nexus Mobile included.",
    features: [
      "Nexus Mobile access",
      "Up to 100 mobile members",
      "2 simultaneous tables",
      "100 monthly active members",
      "3 tournaments per month",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    monthlyPrice: 300,
    annualPrice: 250,
    summary: "Premium operations with AI analytics, support, and usage-based active member billing.",
    priceQualifier: "base",
    usageNote: "plus per active member who played that month",
    features: [
      "Full AI-powered analytics",
      "AI operations chatbot",
      "Rewards, tiers, and referral tools",
      "Automated monthly reports",
      "Unlimited tables, member records, and tournaments",
      "Usage billing only counts active members who played",
      "24/7 support",
    ],
    featured: true,
  },
];
